import { PublicationType } from "@colibrio/colibrio-reader-framework/colibrio-core-publication-base";
import { ScrollRendererGotoScrollBehavior, type IMouseEngineEventData, type IPointerEngineEventData, type IReaderPublication } from "@colibrio/colibrio-reader-framework/colibrio-readingsystem-base";
import type { IEpubReaderPublication } from "@colibrio/colibrio-reader-framework/colibrio-readingsystem-formatadapter-epub";
import type { IPdfReaderPublication } from "@colibrio/colibrio-reader-framework/colibrio-readingsystem-formatadapter-pdf";
import type { IWpAudiobookReaderPublication } from "@colibrio/colibrio-reader-framework/colibrio-readingsystem-formatadapter-wp-audiobook";
import { CirrusReaderPublicationLandmarkType } from "../shared/CirrusReaderModel";

export const useCirrusReaderUtils = () => {
    const isEpubReaderPublication = (readerPublication: IReaderPublication): readerPublication is IEpubReaderPublication => {
        return readerPublication.getSourcePublication().getType() === PublicationType.EPUB;
    }

    const isPdfReaderPublication = (readerPublication: IReaderPublication): readerPublication is IPdfReaderPublication => {
        return readerPublication.getSourcePublication().getType() === PublicationType.PDF;
    }

    const isWpAudiobookReaderPublication = (readerPublication: IReaderPublication): readerPublication is IWpAudiobookReaderPublication => {
        return readerPublication.getSourcePublication().getType() === PublicationType.WP;
    }

    const eventDataIsMouseEngineEventData = (eventData: MouseEvent | IMouseEngineEventData): eventData is IMouseEngineEventData => {
        return (eventData as IMouseEngineEventData).readerViewName !== undefined;
    }

    const eventDataIsPointerEngineEventData = (eventData: PointerEvent | IPointerEngineEventData): eventData is IPointerEngineEventData => {
        return (eventData as IPointerEngineEventData).readerViewName !== undefined;
    }

    const isCirrusReaderPublicationLandmarkType = (landmarkType: string): landmarkType is CirrusReaderPublicationLandmarkType => {
        return Object.values(CirrusReaderPublicationLandmarkType).some((type) => type === landmarkType);
    }

    const isColibrioScrollRendererGotoScrollBehavior = (behaviorName: string): behaviorName is ScrollRendererGotoScrollBehavior => {
        return behaviorName === ScrollRendererGotoScrollBehavior.SCROLL_IF_OUTSIDE_READING_AREA ||
            behaviorName === ScrollRendererGotoScrollBehavior.SCROLL_IF_OUTSIDE_VISIBLE_RANGE ||
            behaviorName ===  ScrollRendererGotoScrollBehavior.ALWAYS_SCROLL;
    }

    return {
        isEpubReaderPublication,
        isPdfReaderPublication,
        isWpAudiobookReaderPublication,
        eventDataIsMouseEngineEventData,
        eventDataIsPointerEngineEventData,
        isCirrusReaderPublicationLandmarkType,
        isColibrioScrollRendererGotoScrollBehavior,
    }

}
